import { EntityState } from '@ngrx/entity';
import { Consumer } from '@app/resources/services';

export interface ConsumerState extends EntityState<Consumer> {
  selectedConsumerId: number | null;
  hasLoaded: boolean;
}
